import { render, staticRenderFns } from "./FormPFDS.vue?vue&type=template&id=10a7c378&scoped=true"
import script from "./FormPFDS.vue?vue&type=script&lang=js"
export * from "./FormPFDS.vue?vue&type=script&lang=js"
import style0 from "./FormPFDS.vue?vue&type=style&index=0&id=10a7c378&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a7c378",
  null
  
)

export default component.exports